import { observer } from "mobx-react-lite";

import { SvgGenerator, type Path } from "@/components/expression/svgUtils/SvgGenerator";

import type { DecoratorNodeModel } from "@/models/nodes/DecoratorNodeModel";

const TILDE_PATH: Path = [
  "stroke",
  "M 1 {75h} C {25w} 0, {25w} 0, {50w} {50h} S {75w} {100h}, {100w-1} {25h}",
];

type Props = {
  node: DecoratorNodeModel;
};

export const WideTilde = observer(function WideTilde({ node: _node }: Props) {
  return (
    <div className="absolute -left-[1px] -right-[1px] text-document-text h-1.5 top-[2px] -translate-y-full">
      <SvgGenerator paths={[TILDE_PATH]} />
    </div>
  );
});
